export const Bio = {
  name: "Nikil kumaar N",
  roles: [
    "Full Stack Developer",
    "MERN Developer",
    "Front-End Developer",
    "Back-End Developer",
  ],
  description:
    "Enthusiastic full stack developer skilled in front-end and back-end web development. Proficient in HTML, CSS, JavaScript, React.js, Node.js, and MongoDB. Strong problem-solving skills and a proactive learner eager to contribute to innovative projects.",
  github: "https://github.com/NikilKumaar",
  resume:
    "https://drive.google.com/file/d/1ZXN_jVvFlhdGrUTtHeimvpQ0Ov70p3EZ/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/nikil-kumaar-n-9401b2295",
  insta: "https://www.instagram.com/call_me_as_nike/",
  phone: "tel:+91 8667805987",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Redux",
        image:
          "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "TailwindCSS",
        image: "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/Tailwind_CSS_Logo.svg/1200px-Tailwind_CSS_Logo.svg.png",
      }
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "Express Js",
        image:
          "data:image/png;base64,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",
      },
      {
        name: "Firebase",
        image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
      },
    ],
  },
  {
    title: "DataBase",
    skills: [
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
    ],
  },
  {
    title: "Programming Languages",
    skills: [
      {
        name: "Java",
        image:
          "https://www.citypng.com/public/uploads/preview/hd-java-logo-transparent-background-701751694771845zainlxmlfo.png",
      },
      {
        name: "Python",
        image:
          "https://cdn.icon-icons.com/icons2/2415/PNG/512/python_original_logo_icon_146381.png",
      },
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image:
          "https://e7.pngegg.com/pngimages/713/558/png-clipart-computer-icons-pro-git-github-logo-text-logo-thumbnail.png",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "Vercel",
        image:
          "https://w7.pngwing.com/pngs/436/888/png-transparent-vercel-hd-logo.png",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Postman",
        image:
          "https://images.seeklogo.com/logo-png/44/1/postman-api-platform-logo-png_seeklogo-446859.png",
      },
    ],
  },
];

export const education = [
  {
    id: 0,
    img: "https://images.crunchbase.com/image/upload/c_lpad,h_256,w_256,f_auto,q_auto:eco,dpr_1/dhegzt7blhr2xmb8pdjw",
    school:
      "UNIQ TECHNOLOGIES, Shifa arcade No 1, 3rd floor, Bharathinagar 1st street, North Usman Road, T.Nagar, Chennai, TamilNadu - 600 017",
    date: "August 2025 - September 2025",
    grade: " A+",
    desc: "The 1-month Java course at Uniq Technologies covers everything from Java basics to OOP concepts and advanced core features. I gained hands-on experience with topics like exception handling, collections, and multithreading, building a strong foundation to develop java applications.",
    degree: "Java Programming Language",
  },
  {
    id: 1,
    img: "https://images.g2crowd.com/uploads/product/image/large_detail/large_detail_b2b52bf26a769b861fae19c5f65643cf/guvi.png",
    school:
      "GUVI GEEK NETWORK PRIVATE LIMITED, IITM Research park, Tharamani, Chennai, Tamil Nadu - 600 113",
    date: "Feb 2024 - April 2024",
    grade: " A+",
    desc: "During my time at GUVI GEEK NETWORK, I underwent comprehensive training as a MERN Stack Developer, focusing on mastering the MongoDB, Express.js, React.js and Node.js technologies. Through a blend of theoretical learning and hands-on practical exercises, I acquired a solid understanding of both front-end and back-end development aspects.",
    degree: "Full Stack Developer",
  },
  {
    id: 2,
    img: "https://college4u.in/wp-content/uploads/2018/03/ktc00.png",
    school:
      "Kumaraguru College of Technology, Saravanampatti, Coimbatore - 641 049",
    date: "Aug 2016 - May 2020",
    grade: "8.2 CGPA",
    desc: "I am Engineering Graduate Specialized in Mechanical Engineering at Kumaraguru College of Technology, Saravanampatti, Coimbatore - 641 049.",
    degree: "Bachelor of Engineering - B.E. Mechanical Engineering",
  },
  {
    id: 3,
    img: "https://yt3.ggpht.com/a/AATXAJzYzBlk1HuVdMmJiGaEatoyqqv0crK-cwc3EQ=s900-c-k-c0xffffffff-no-rj-mo",
    school: "Veveaham Higher Secondary School, Dharapuram - 638 657",
    date: "Apr 2015 - Apr 2016",
    grade: "90.58%",
    desc: "I completed my class 12 high school education at Veveaham Higher Secondary School, Dharapuram, where I studied Computer Science group.",
    degree: "HSC(XII), Computer Science",
  },
  {
    id: 4,
    img: "https://yt3.ggpht.com/a/AATXAJzYzBlk1HuVdMmJiGaEatoyqqv0crK-cwc3EQ=s900-c-k-c0xffffffff-no-rj-mo",
    school: "Veveaham Higher Secondary School, Dharapuram - 638 657",
    date: "Apr 2013 - Apr 2014",
    grade: "92.6%",
    desc: "I completed my class 10 education at Veveaham Higher Secondary School, Dharapuram.",
    degree: "SSLC(X)",
  },
];

export const projects = [
  {
    id: 1,
    title: "Diary App",
    date: "June 2024",
    description:
      "Welcome to the Diary Application website!. This project is built using the MERN stack (MongoDB, Express.js, React.js, Node.js), providing a platform for users to create new diary entries, editing existing ones, and delete entriees.It helps users to save their personal datas and also used to store their valuable memories",
    image:
      "https://github.com/NikilKumaar/Diary-App---FrontEnd/raw/main/public/Diary%20App.png",
    tags: [
      "React Js",
      "Bootstrap",
      "MongoDB",
      "Node Js",
      "Express Js",
      "Axios",
      "Toastify",
      "react-router-dom",
      "bcrypt",
      "cors",
      "dotenv",
      "JWT",
      "Nodemailer",
    ],
    category: "web app",
    github: "https://github.com/NikilKumaar/Diary-App---FrontEnd",
    webapp: "https://diaryapp-fe.netlify.app/",
  },
  {
    id: 2,
    title: "Inventory Management and Billing",
    date: "July 2024",
    description:
      "Our inventory management and billing app leverages the power of the MERN stack to provide businesses with a robust solution for tracking inventory, managing stock levels, and generating invoices seamlessly. Whether you operate a retail store, warehouse, or e-commerce platform, our app offers comprehensive features to streamline your operations and enhance efficiency.",
    image:
      "https://github.com/NikilKumaar/Inventory-Management-and-Billing---Frontend/raw/main/public/IMBA.png",
    tags: [
      "React Js",
      "MongoDB",
      "Node Js",
      "Express Js",
      "sweetalert2",
      "Razorpay",
      "daisy UI",
      "easy-invoice",
      "bcryptjs",
      "node js",
      "cors",
      "dotenv",
      "JWT",
      "Formik-Yup",
      "Nodemailer",
    ],
    category: "web app",
    github:
      "https://github.com/NikilKumaar/Inventory-Management-and-Billing---Frontend",
    webapp: "https://inventorymanagementandbilling.netlify.app/",
  },
  {
    id: 3,
    title: "Todo App",
    date: "June 2024",
    description:
      "A To-Do Full Stack MERN App is a task management application built using MongoDB, Express.js, React, and Node.js. It allows users to add, edit and delete. The app features a React-based front-end and a Node.js/Express back-end with MongoDB for data storage.",
    image:
      "https://github.com/NikilKumaar/todo-frontend/raw/master/public/TodoApp.png",
    tags: [
      "React Js",
      "Bootstrap",
      "Fetch-api",
      "cors",
      "MongoDB",
      "Express Js",
      "Node Js",
      "Nodemon",
    ],
    category: "web app",
    github: "https://github.com/NikilKumaar/todo-frontend",
    webapp: "https://todo-frontendapp.netlify.app/",
  },
  {
    id: 4,
    title: "Travel Planner App",
    date: "May 2024",
    description:
      "Our travel planner app using the MERN stack is designed to simplify the process of planning and organizing trips for travelers. Whether you're planning a solo adventure, family vacation, or business trip, our app provides essential tools to manage itineraries, accommodations, activities, and expenses efficiently.",
    image:
      "https://github.com/NikilKumaar/Travel-Planner-App/raw/main/public/Travel%20Planner.png",
    tags: [
      "React Js",
      "bootstrap",
      "MongoDB",
      "Node Js",
      "Express Js",
      "Mongoose",
      "bcryptjs",
      "dotenv",
      "JWT",
      "cors",
      "dotenv",
      "braintree",
      "Firebase",
    ],
    category: "web app",
    github: "https://github.com/NikilKumaar/Travel-Planner-App",
    webapp: "https://mern-travel-tourism-app.onrender.com/",
  },
  {
    id: 5,
    title: "Zen Class Student Dashboard",
    date: "July 2024",
    description:
      "Our Zen class student dashboard website is designed to enhance the experience of students participating in Zen meditation and mindfulness classes. This platform provides students with tools to track their progress, access resources, and engage with the Zen community, fostering a harmonious learning environment.",
    image:
      "https://github.com/NikilKumaar/Zen-Class-Student-Dashboard---FrontEnd/raw/main/public/Zen%20Class.png",
    tags: [
      "React Js",
      "bootstrap",
      "Axios",
      "MongoDB",
      "Node Js",
      "Express Js",
      "Mongoose",
      "bcryptjs",
      "dotenv",
      "JWT",
      "cors",
      "dotenv",
      "Nodemailer",
      "Mongoose",
    ],
    category: "web app",
    github:
      "https://github.com/NikilKumaar/Zen-Class-Student-Dashboard---FrontEnd",
    webapp: "https://zen-class-student-dashboard-fe.netlify.app/",
  },
  {
    id: 6,
    title: "Twitter Clone",
    date: "December 2024",
    description:
      "A Twitter clone built with the MERN stack (MongoDB, Express, React, Node.js) featuring user authentication, tweet posting, and updating user information. The front-end is styled using Tailwind CSS with DaisyUI for responsive, customizable components. This project showcases a full-stack social media app with modern UI design.",
    image: "https://github.com/NikilKumaar/twitter-clone/raw/main/x-clone.png",
    tags: [
      "React Js",
      "TailwindCSS",
      "daisyui",
      "fetch",
      "MongoDB",
      "Node Js",
      "Express Js",
      "Mongoose",
      "bcryptjs",
      "dotenv",
      "JWT",
      "cors",
      "cloudinary",
      "nodemon",
    ],
    category: "web app",
    github: "https://github.com/NikilKumaar/twitter-clone",
    webapp: "https://twitter-clone-8l8x.onrender.com",
  },
];
